import { Component } from '@angular/core';

@Component({
  selector: 'app-admin-settings',
  template: `
    <div class="flex flex-col items-center justify-center py-20 text-center">
      <div class="flex h-14 w-14 items-center justify-center rounded-xl bg-zinc-100">
        <lucide-icon name="settings" [size]="24" class="text-zinc-400" [strokeWidth]="1.5"></lucide-icon>
      </div>
      <h2 class="mt-4 text-sm font-semibold text-zinc-900">Admin Settings</h2>
      <p class="mt-1.5 max-w-xs text-xs text-zinc-500">
        Feature flags, rate limits, and platform configuration will be managed here.
      </p>
    </div>
  `,
})
export class AdminSettingsComponent {}
